<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="500px"
    :inner-scroll="false"
    :loading="loading"
    @confirm="confirm"
    @cancel="cancel"
    @close="cancel"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="产品编码" prop="productCode">
        <el-input v-model.trim="form.productCode" placeholder="请输入产品编码"></el-input>
      </el-form-item>
      <el-form-item label="产品分类" prop="categoryName">
        <el-input v-model.trim="form.categoryName" placeholder="请输入产品分类"></el-input>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'ProductCategoryDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      form: {
        categoryName: '',
        productCode: '',
      },
      rules: {
        productCode: [{ required: true, message: '请输入产品编码', trigger: 'blur' }],
        categoryName: [{ required: true, message: '请输入产品分类', trigger: 'blur' }],
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    isEdit() {
      return !!this.rowData.dataId;
    },
    title() {
      return this.isEdit ? '编辑产品分类' : '新增产品分类';
    },
  },
  created() {
    if (this.isEdit) {
      this.form = {
        categoryName: this.rowData.categoryName,
        dataId: this.rowData.dataId,
        productCode: this.rowData.productCode,
      };
    }
  },
  methods: {
    cancel() {
      this.isVisible = false;
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const request = this.isEdit
          ? this.$q.preSalePlan.preSaleProductCategoryUpdate({ data: this.form })
          : this.$q.preSalePlan.preSaleProductCategorySave({ data: this.form });
        request.then((res) => {
          if (res.success) {
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
            this.$emit('success');
            this.cancel();
          } else {
            this.$message.error(res.message || '保存失败');
          }
        }).finally(() => {
          this.loading = false;
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input
  width 300px
</style>
